<template>
    <div class="circle-tabs__content pt0">
        <MapContainer></MapContainer>

        <EuropeanSpace v-if="this.$router.currentRoute.fullPath === '/?info=cartela' || this.$router.currentRoute.fullPath === '/#/?info=cartela'"></EuropeanSpace>

        <div v-if="this.$router.currentRoute.fullPath === '/?info=cartela'">
            <div class="spring">
                <h2 class="heading heading--3 heading--light heading--center">Oferte Cartela Vodafone</h2>
                <slick class="ro_slider" :options="slickOptions">
                    <!-- <offer-prepaid-1_ic></offer-prepaid-1_ic> -->
                    <offer-prepaid-4_ic></offer-prepaid-4_ic>
                    <offer-prepaid-15_ic></offer-prepaid-15_ic>
                    <offer-prepaid-35_ic></offer-prepaid-35_ic>
                </slick>
            </div>
        </div>

        <div class="spring">
            <h2 class="heading heading--3 heading--light">Informații importante Roaming</h2>
        </div>

        <Accordion></Accordion>

        <GeneralInfo></GeneralInfo>
    </div>
</template>

<script>
import MapContainer from './MapContainer';
import EuropeanSpace from './EuropeanSpace';
import TarifeStandard from './TarifeStandard';
import Accordion from './Accordion';
import OfferPrepaid_1_ic from './OfferPrepaid_1_ic.vue';
import OfferPrepaid_4_ic from './OfferPrepaid_4_ic.vue';
import OfferPrepaid_15_ic from './OfferPrepaid_15_ic.vue';
import OfferPrepaid_35_ic from './OfferPrepaid_35_ic.vue';
import GeneralInfo from './Generalinfo';
import Slick from './slickCarousel';

export default {
    name: 'MainPage',
    components: {
        MapContainer,
        EuropeanSpace,
        TarifeStandard,
        Accordion,
        'offer-prepaid-1_ic': OfferPrepaid_1_ic,
        'offer-prepaid-4_ic': OfferPrepaid_4_ic,
        'offer-prepaid-15_ic': OfferPrepaid_15_ic,
        'offer-prepaid-35_ic': OfferPrepaid_35_ic,
        GeneralInfo,
        Slick,
    },
    data() {
        return {
            slickOptions: {
                infinite: false,
                arrows: true,
                dots: false,
                speed: 500,
                // slidesToShow: 3,
                slidesToScroll: 1,
                adaptiveHeight: true,
                mobileFirst: true,
                autoplay: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            initialSlide: 1,
                        },
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            initialSlide: 1,
                        },
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            initialSlide: 1,
                        },
                    },
                ],
            },
        };
    },
    mounted() {
        this.$nextTick(() => {
            dataLayer.push({
                event: 'microData',
                event_name: 'page_view',
                page_name: `Roaming Homepage LP`,
                page_type: 'landing_page',
                page_platform: 'website',
                page_charset: 'UTF-8',
                page_country: 'RO',
                page_domain: 'vodafone.ro',
                page_locale: 'RO-ro',
                page_section: 'roaming',
                page_channel: 'vodafone.ro',
                user_selected_journey: 'NO_FLOW',
                client_upc: 'no',
            });
        });
    },
};
</script>
